import { render } from "./menu.vue?vue&type=template&id=8163526c"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\avue\\avue3.0\\avue\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.27_typescript@5.9.3__webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/element-plus/form/menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8163526c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8163526c', __exports__)) {
    console.log('reload')
    api.reload('8163526c', __exports__)
  }
  
  module.hot.accept("./menu.vue?vue&type=template&id=8163526c", () => {
    console.log('re-render')
    api.rerender('8163526c', render)
  })

}


export default __exports__